/**
 * @module utilities/validation
 */

import schemaHelper from '@utilities/schemaHelper'

import Ajv from 'ajv'
export const ajv = new Ajv({
  //  $data: true,
  allErrors: true,
  jsonPointers: true,
  useDefaults: true,
  extendRefs: 'fail',
  verbose: true,
  coerceTypes: false,
  messages: true
})
const ajvErrorsDecorator = require('ajv-errors')
ajvErrorsDecorator(ajv)
// maybe use https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/ajv-errors ?

export function getValidator(schemaId: string) {
  return schemaHelper.getValidator(ajv, schemaId)
}

export function getSchema(schemaId: string) {
  return schemaHelper.getSchema(ajv, schemaId)
}

export function addSchema(schemaId: string) {
  return schemaHelper.addSchema(ajv, schemaId)
}

ajv.addMetaSchema(require('ajv/lib/refs/json-schema-draft-06.json'))

export function isEmpty(value: any) {
  return value !== value || value === null || String(value).trim().length < 1
}

/**
 * Format list of errors returned by AJV into a dict of error messages mapped
 * against the field names.
 */
export function formatErrors(errors: any) {
  let formattedErrors: any = null
  if (errors) {
    formattedErrors = {}
    for (const error of errors) {
      // https://github.com/epoberezkin/ajv#error-parameters
      const origError =
        Array.isArray(error.params.errors) && error.params.errors[0]
          ? error.params.errors[0]
          : error
      let fieldName
      if (origError.keyword == 'required' && origError.params.missingProperty != null) {
        fieldName = origError.params.missingProperty
      } else if (
        ['type', 'minProperties', 'minimum', 'maximum', 'pattern'].includes(origError.keyword)
      ) {
        fieldName = error.dataPath.slice(1)
      }
      formattedErrors[fieldName] = error.message
    }
  }
  return formattedErrors
}
